export const usePackagingsData = () => {
    const packagings = [
    {
        title: 'Защитная транспортировочная упаковка',
        subtitles: ['Самый востребованный и распространенный вид упаковки, надежно оберегающий груз от нежелательных воздействий. Габариты или форма груза не имеют значения – данный вид упаковки одинаково хорош и для хрупкой люстры, и для массивного дивана, и для гоночного байка.'],
        description: 'Защитная транспортировочная упаковка предоставляется на время транспортировки груза, получателю не передается.',
        img: '/images/upakovka/ju.png',
        lists: [
            { img: '/images/upakovka/icon/box.svg', text: 'Пластиковая и металлическая тара' },
            { img: '/images/upakovka/icon/cpu.svg', text: 'Техника' },
            { img: '/images/upakovka/icon/car.svg', text: 'Автозапчасти' },
            { img: '/images/upakovka/icon/glass.svg', text: 'Хрупкие предметы' }
        ],
        info: {
            tables: [
                {
                    title: 'Стоимость упаковки:',
                    head: ['Пункт', 'Направления', { html: 'Для грузов, которые помещаются в палетную раму*' }, { html: 'Для грузов, которые НЕ помещаются в палетную раму*' }],
                    rows: [
                        ['1', 'Все, за исключением городов и отделений, указанных в п.2, п.3, п.4', { html: '39,06 BYN/м³ <br> минимальная стоимость 20,03 BYN' },{ html: '110,52 BYN/м³ <br> минимальная стоимость 53,82 BYN' }],
                        ['2', 'При отправке грузов из: Адлер Веселое, Александров, Алексеевка, Анапа, Астрахань, Балашиха, Балашов, Барнаул, Барнаул Власихинская, Березники, Белгород, Бор, Борисоглебск Матросовская, Боровичи, Бугульма, Великие Луки, Владимир, Владикавказ ФР, Волхов, Вольск, Волжский, Воронеж, Воронеж Солнечная, Воскресенск, Выборг Ленинградское, Выкса, Вышний Волочек, Вязники, Вязьма, Вятские Поляны, Гай, Горки Ленинские, Грозный, Гурьевск, Долгопрудный Грибки, Домодедово, Дубна, Евпатория, Егорьевск, Елабуга, Екатеринбург, Железногорск, Жирновск, Заводоуковск, Иваново, Ижевск, Казань, Карасук, Касимов, Козельск, Кореновск, Краснодар, Краснодар Круговая, Краснокамск, Крымск, Кунгур, Курчатов, Лабинск, Ленинградская Станица, Ленинск-Кузнецкий, Людиново, Майкоп Транспортная, Минусинск, Михайловка, Моршанск, Москва, Москва Дзержинский, Москва Молодогвардейская, Муром Владимирское, Набережные Челны, Надым, Назрань, Нижний Новгород, Новосибирск, Новомосковск, Новоуральск, Новошахтинск, Ноябрьск, Нурлат, Обнинск Киевское, Омск, Омск Производственная, Орехово-Зуево Урицкого, Острогожск, Пенза, Пермь, Пермь Героев Хасана, Петрозаводск Перевалка, Петропавловск-Камчатский, Прохладный, Пушкино, Пятигорск, Раменское, Ржев, Рославль, Россошь Мира, Ростов-на-Дону, Ростов-на-Дону Восток, Ртищево, Рузаевка, Самара, Санкт-Петербург, Санкт-Петербург Энергетиков, Саратов, Сергиев Посад Фабричная, Серпухов, Смоленск, Сочи, Стерлитамак Элеваторная, Ступино, Сызрань Речной порт, Сызрань Хвалынская, Талица, Тара, Тихорецк, Туапсе, Томск, Тюмень, Удомля, Урюпинск, Уфа, Феодосия, Челябинск, Черкесск, Шарья, Шебекино, Шумиха, Щекино, Щелково, Элиста, Ярославль, Ярославль Пожарского, Ярцево, Ясный, + МО.', { html: '39,9 BYN/м³ <br> минимальная стоимость 21,42 BYN' },{ html: '100,8 BYN/м³ <br> минимальная стоимость 54,3 BYN' }],
                        ['3', 'При отправке грузов из: Артем, Алексин, Ачинск, Балахна, Бийск Шадрина, Братск Южная, Благовещенск, Бугуруслан, Бузулук, Братск Южная, Брест, Верхняя Салда, Владивосток, Волгоград, Волгоград Красноармейский, Георгиевск, Губкин, Дальнегорск, Елец, Зеленоград, Ирбит, Иркутск, Канск, Клин, Комсомольск-на-Амуре, Красноярск, Каменск-Уральский Карла Маркса, Камышин, Канск, Кирово-Чепецк, Клинцы, Краснокаменск, Красноярск Вавилова, Красноярск Северный, Кулебаки, Кызыл, Лесосибирск, Лысьва, Махачкала, Миасс, Магадан, Мичуринск, Минск, Наро-Фоминск Киевское шоссе, Находка, Нефтекамск Высоковольтная, Новый Уренгой, Ногинск, Норильск Море, Норильск Река, Углич, Ухта, Улан-Удэ, Уссурийск, Оренбург Юг, Первоуральск, Саров, Солнечногорск, Степное Озеро, Спасск-Дальний, Таганрог Западный, Тулун, Хабаровск, Хасавюрт, Чайковский, Чита, Южно-Сахалинск Ленина, Якутск.', { html: '40,74 BYN/м³<br> минимальная стоимость 25,47 BYN' }, { html: '101,64 BYN/м³<br> минимальная стоимость 47,88 BYN' }],
                        ['4', 'При отправке грузов из городов республики Казахстан.',  { html: '67,2 BYN/м³ <br> минимальная стоимость 39,02 BYN' },  { html: '158,76 BYN/м³ <br> минимальная стоимость  81,48 BYN' }]
                    ],
                    footer: '*Внутренние размеры палетной рамы: длина 1,1 м, ширина 0,7 м, высота 1,55 м.'
                }
            ],
            additionalHtml: `
                <div style="display: flex; gap:12px; align-items: flex-start;">
                    <div style="margin-right: 10px;">
                        <img src="/images/upakovka/icon/warning.svg" alt=""  style="width: 24px; height: 24px;">
                    </div>
                    <div>
                        <p>Стоимость перевозки автомобильным транспортом с использованием защитной транспортировочной упаковки увеличивается на 35%; для авиаперевозки – на 40%.</p>
                        <p>Стоимость Защитной транспортировочной упаковки, при максимальном габарите грузового места от 2,4 м до 6 м стоимость увеличивается на 25%; от 6 м стоимость увеличивается на 50%.</p>
                    </div>
                </div>
                `
        }
    },
    {
        title: 'Неразборная защитная транспортировочная упаковка',
        subtitles: ['Преимущество такой транспортировочной упаковки в том, что вы можете использовать её в дальнейшем для отправки других грузов или на своё усмотрение. Крепкая и надежная защитная упаковка прослужит долго! Неразборную защитную транспортировочную упаковку вы забираете вместе с грузом.'],
        img: '/images/upakovka/n-sep.png',
        detailsImg: ['/images/upakovka/n-sep_2.png'],
        lists: [
            { img: '/images/upakovka/icon/tabler_motorbike.svg', text: 'Вело- и мототехника' },
            { img: '/images/upakovka/icon/box.svg', text: 'Пластиковая и металлическая тара' },
            { img: '/images/upakovka/icon/cpu.svg', text: 'Техника' },
            { img: '/images/upakovka/icon/tabler_armchair.svg', text: 'Мебель' },
            { img: '/images/upakovka/icon/car.svg', text: 'Автозапчасти' },
            { img: '/images/upakovka/icon/glass.svg', text: 'Хрупкие предметы' },
        ],
        info: {
            title: 'Стоимость упаковки:',
            tables: [
                {
                    head: ['Пункт', 'Направления', 'Стоимость'],
                    rows: [
                        ['1', 'Все, за исключением городов, указанных в п.2.', { html: '102,06 BYN за 1 м<sup>3</sup> , минимальная стоимость — 49,14 BYN' }],
                        ['2', 'При отправке грузов из городов Республики Казахстан', { html: '182,7 BYN за 1 м<sup>3</sup> , минимальная стоимость — 97,44 BYN' }]
                    ]
                }
            ],
            additionalHtml: `
                <div style="display: flex; gap:12px; align-items: flex-start;">
                     <div style="margin-right: 10px;">
                        <img src="/images/upakovka/icon/warning.svg" alt=""  style="width: 24px; height: 24px;">
                    </div>
                    <div style=" font-weight: 400; font-style: Regular; font-size: 14px; leading-trim: NONE; line-height: 20px; letter-spacing: 0%;">
                        <p><b>Стоимость перевозки автомобильным транспортом с использованием неразборной защитной транспортировочной упаковки увеличивается на 35%; для авиаперевозки - на 40%.</b></p>
                        <p>Стоимость Неразборной защитной транспортировочной упаковки, при максимальном габарите грузового места от 2,4 м до 6 м увеличивается на 25%; от 6 м стоимость увеличивается на 50%.</p>
                        <p><b>Данный вид упаковки обязателен для отправлений в город Калининград, а также рекомендателен для отправлений любой мебели и сантехники.</b></p>
                        <p>Неразборная защитная транспортировочная упаковка после перевозки передаётся клиенту вместе с грузом и может быть разобрана по его просьбе.</p>
                    </div>
                </div>
            `
        }
    },
    {
        title: 'Картонная коробка',
        subtitles: ['Книги, коллекция любимых пластинок, архив документов, детские игрушки – всё то, что нуждается и в защите, и в объединенной транспортировке, должно быть упаковано в коробку из плотного картона. Стрейч-пленка и стреппинг-лента обеспечивают коробке дополнительную плотность и еще надежнее защищают груз.'],
        warning: 'Упаковка для грузов менее 3 кг обязательна!',
        img: '/images/upakovka/kk_1.png',
        detailsImg: ['/images/upakovka/kk_2.png', '/images/upakovka/kk_4.png'],
        lists: [
            { img: '/images/upakovka/icon/tabler_horse-toy.svg', text: 'Игрушки' },
            { img: '/images/upakovka/icon/tabler_glass-gin.svg', text: 'Посуда' },
            { img: '/images/upakovka/icon/book.svg', text: 'Книги' },
            { img: '/images/upakovka/icon/star.svg', text: 'Елочные игрушки' },
            { img: '/images/upakovka/icon/tdesign_curtain.svg', text: 'Гардины' },
            { img: '/images/upakovka/icon/tabler_shirt.svg', text: 'Одежда' },
        ],
        info: {
            title: 'Размеры коробок и их стоимость за 1 шт.:',
            tables: [
                {
                    title: 'Картонная коробка',
                    head: ['Пункт', 'Направления', 'Габариты и стоимость'],
                    rows: [
                        ['1', 'Все, за исключением городов, указанных в п.2', {html: '30 × 20 × 20 см &ndash; 3,99 BYN,<br> 37 × 28 × 39 см &ndash; 5,67 BYN,<br> 57 × 37 × 39 см &ndash; 7,77 BYN'}],
                        ['2', 'Артем, Благовещенск, Братск, Владивосток, Иркутск, Комсомольск-на-Амуре, Магадан, Петропавловск-Камчатский, Улан-Удэ, Уссурийск, Хабаровск, Чита, Южно-Сахалинск', {html: '30 × 20 × 20 см &ndash; 4,2 BYN,<br> 37 × 28 × 39 см &ndash; 6,09 BYN,<br> 57 × 37 × 39 см &ndash; 8,19 BYN'}]
                    ]
                },
                {
                    title: 'Усиленная картонная коробка',
                    subtitle: 'Альтернатива «Защитной транспортировочной упаковки»: благодаря усиленной конструкции дна и крышки, она защищает груз так же надежно, но является более экономичным вариантом.',
                    head: ['Пункт', 'Направления', 'Габариты и стоимость'],
                    rows: [
                        ['1', 'Все, за исключением городов, указанных в п.2', {html: '20 × 20 × 10 см &ndash; 3,15 BYN,<br> 35 × 25 × 15 см &ndash; 4,41 BYN,<br> 30 × 20 × 20 см &ndash; 5,25 BYN,<br> 37 × 28 × 39 см &ndash; 7,77 BYN,<br> 57 × 37 × 39 см &ndash; 11,55 BYN'}],
                        ['2', 'Артем, Благовещенск, Братск, Владивосток, Иркутск, Комсомольск-на-Амуре, Магадан, Петропавловск-Камчатский, Улан-Удэ, Уссурийск, Хабаровск, Чита, Южно-Сахалинск', {html: '20 × 20 × 10 см &ndash; 3,36 BYN,<br> 35 × 25 × 15 см &ndash; 4,83 BYN,<br> 30 × 20 × 20 см &ndash; 5,67 BYN,<br> 37 × 28 × 39 см &ndash; 8,19 BYN,<br> 57 × 37 × 39 см &ndash; 13,23 BYN'}]
                    ]
                }
            ],
            additionalHtml: `
            <div style=" font-weight: 400; font-style: Regular; font-size: 14px; leading-trim: NONE; line-height: 20px; letter-spacing: 0%;">
                <p>Дополнительно можно приобрести стреппинг-ленту 12 мм, которая повышает жесткость картонных коробок.</p>
                <p><b>Стоимость –  2,31 BYN/м<sup>3</sup></b></p>
            </div>
            `
        }
    },
    {
        title: 'Выдача груза на поддоне',
        subtitles: ['Услуга предназначена для отправлений, при выдаче которых затруднительна ручная перегрузка и используется погрузчик. Подходит для грузовых мест весом более 50 кг каждое. Услугу можно заказать только на этапе приемки при самостоятельной сдачи груза на склад и в Сервисном отделе компании.'],
        img: '/images/upakovka/pal_1.png',
        lists: [
            { img: '/images/upakovka/icon/car.svg', text: 'Автозапчасти' },
            { img: '/images/upakovka/icon/tabler_tool.svg', text: 'Оборудование, станки' },
            { img: '/images/upakovka/icon/tabler_salt.svg', text: 'Сыпучие грузы' },
            { img: '/images/upakovka/icon/la_pallet.svg', text: 'Запалетированные грузы' }
        ],
        info: {
            additionalHtml: `
                <p><b>Стоимость услуги:</b></p>
                <ul>
                    <li>13,86 BYN за одно грузовое место</li>
                    <li>услуга доступна во всех филиалах ПЭК</li>
                </ul>
                <div style="display: flex; gap:12px; align-items: flex-start;">
                     <div style="margin-right: 10px;">
                        <img src="/images/upakovka/icon/warning.svg" alt=""  style="width: 24px; height: 24px;">
                    </div>
                    <div>
                        <p>Данная услуга доступна для заказа, как при приемке груза в городе отправления, так и в сервисном отделе в городе получения груза</p>
                    </div>
                </div>
            `
        }
    },
    {
        title: 'Транспортное основание',
        subtitles: [
            'Идеальное решение для грузов, которым не требуется жесткая упаковка, но из-за веса и/или габаритов необходима основа для безопасного перемещения. Эта услуга сокращает ваши затраты, при этом надежность перевозки остается на высоком уровне.',
            'Для вашего груза будет изготовлено индивидуальное транспортное основание, обеспечивающее устойчивость и удобство при погрузке и разгрузке.',
        ],
        img:'/images/upakovka/cargo 1.png',
        detailsImg: ['/images/upakovka/cargo5.png'],
        description:'Выдача груза производится вместе с Транспортным основанием по усмотрению Клиента.',
        lists: [
            { img: '/images/upakovka/icon/building-3.svg', text: 'Металлоконструкции монолитные' },
            { img: '/images/upakovka/icon/weight.svg', text: 'Изделия из металла' },
            { img: '/images/upakovka/icon/hugeicons_gas-pipe.svg', text: 'Трубы и трубопроводы' },
            { img: '/images/upakovka/icon/lucide_cable.svg', text: 'Катушки с кабелем' }
        ],
        info: {
            additionalHtml: `
                <p><b>Стоимость услуги:</b> 31,92 BYN/м³</p>
                <p><b>Минимальная стоимость:</b> 18,06 BYN</p>
                <p><b>Расчет объема груза</b></p>
                <p>При расчете объема груза учитывается увеличение высоты груза на 15 см. Это необходимо для учета пространства, занимаемого транспортным основанием.</p>
                <p><b>Ограничения</b></p>
                <p>Услуга не подходит для хрупких грузов, грузов с хрупкими или выступающими за габариты элементами, а также для грузов с длиной менее 1,2 м.</p>
            `
        }
    },
    {
        title: 'Полипропиленовый мешок',
        subtitles: ['Привычный мешок, идеально подходящий для мелких, сыпучих и мягких грузов, обеспечивает им надежную защиту благодаря суперпрочным современным материалам.'],
        warning: 'Упаковка для грузов менее 3 кг обязательна!',
        img: '/images/upakovka/m_1.png',
        detailsImg: ['/images/upakovka/m_2.png','/images/upakovka/m_3.png'],
        lists: [
            { img: '/images/upakovka/icon/marketeq_carpet-3.svg', text: 'Ковры, ковролин' },
            { img: '/images/upakovka/icon/marketeq_carpet-2.svg', text: 'Линолеум' },
            { img: '/images/upakovka/icon/solar_bed-linear.svg', text: 'Матрасы' },
            { img: '/images/upakovka/icon/tabler_salt.svg', text: 'Сыпучие грузы' },
            { img: '/images/upakovka/icon/setting-2.svg', text: 'Фурнитура' },
        ],
        info: {
            tables: [
                {
                    head: ['Пункт', 'Направления', 'Размер и стоимость'],
                    rows: [
                        ['1', 'Все, за исключением городов, указанных в п.2', {html: '70 × 90 см – 2,94 BYN,<br> 70 × 120 см – 3,36 BYN,<br> 70 × 180 см – 4,41 BYN,<br> 130 × 200 см – 9,03 BYN'}],
                        ['2', 'Артем, Благовещенск, Братск, Владивосток, Иркутск, Комсомольск-на-Амуре, Магадан, Петропавловск-Камчатский, Улан-Удэ, Уссурийск, Хабаровск, Чита, Южно-Сахалинск', {html: '70 × 90 см – 3,36 BYN,<br> 70 × 120 см – 3,78 BYN,<br> 70 × 180 см – 4,83 BYN,<br> 130 × 200 см – 9,45 BYN'}]
                    ],
                    additionalHtml: `
                        <p>Стоимость дополнительной маркировки груза – 0,84 BYN</p>
                    `
                },

                {
                    title: 'ЛАМИНИРОВАННЫЙ МЕШОК',
                    subtitle: 'Правильно подобранный матрас – гарант спокойного сна своего владельца, а специализированный ламинированный мешок – гарант здоровья для самого матраса во время его путешествия.',
                    head: ['Пункт', 'Направления', 'Размер и стоимость'],
                    rows: [
                        ['1', 'Все, за исключением городов, указанных в п.2', '130 × 260 см – 15,54 BYN'],
                        ['2', 'Артем, Благовещенск, Братск, Владивосток, Иркутск, Комсомольск-на-Амуре, Магадан, Петропавловск-Камчатский, Улан-Удэ, Уссурийск, Хабаровск, Чита, Южно-Сахалинск', '130 × 260 см – 15,96 BYN']
                    ]
                }
            ],
             additionalHtml: `
                <p>Используется при перевозке матрасов в следующей комплектации:</p>
                <ul>
                    <li>1 шт. на матрасы с габаритом менее 1 м по ширине;</li>
                    <li>2 шт. на матрасы с габаритом более 1 м по ширине.</li>
                </ul>
            `
        }
    },
    {
        title: 'Специализированная упаковка',
        subtitles: ['Как бы сурово не выглядел автокапот, следует помнить, что он достаточно хрупок, впрочем, как и все остальные детали кузова. Специально для них в ПЭК была разработана система защитной упаковки.'],
        img: '/images/upakovka/s_1.png',
        detailsImg: ['/images/upakovka/s_3.png','/images/upakovka/s_4.png','/images/upakovka/s_5.png','/images/upakovka/s_6.png'],
        lists: [
            { img: '/images/upakovka/icon/car.svg', text: 'Кузовные запчасти' },
        ],
        info: {
            tables: [
                {
                    head: ['Пункт', 'Направление', 'Размеры коробок и их стоимость за 1 шт.', 'Габариты', 'Стоимость'],
                     rows: [
                        ['1', 'Все, за исключением городов, указанных в п.2', 'для автомобильных дверей', '130 × 30 × 135 см', '49,14 BYN'],
                        ['', '', 'для автомобильных бамперов', {html: '200 × 50 × 65 см<br>200 × 50 × 85 см'}, {html: '47,04 BYN<br>53,34 BYN*'}],
                        ['', '', {html: 'для автомобильного стекла<br>(дополнительно оплачивается стоимость защитной транспортировочной упаковки)'}, '155 × 16 × 115 см', '51,24 BYN'],
                        ['', '', 'для автомобильных капотов', '175 × 30 × 135 см', '64,26 BYN'],
                        ['2', 'При отправке грузов из городов: Артем, Благовещенск, Братск, Владивосток, Иркутск, Комсомольск-на-Амуре, Магадан, Петропавловск-Камчатский, Улан-Удэ, Уссурийск, Хабаровск, Чита, Южно-Сахалинск', 'для автомобильных дверей', '130 × 30 × 135 см', '51,24 BYN'],
                         ['', '', 'для автомобильных бамперов', {html: '200 × 50 × 65 см<br>200 × 50 × 85 см'}, {html: '49,14 BYN <br>57,54 BYN*'}],
                        ['', '', {html: 'для автомобильного стекла<br>(дополнительно оплачивается стоимость защитной транспортировочной упаковки)'}, '155 × 16 × 115 см', '54,18 BYN'],
                        ['', '', 'для автомобильных капотов', '175 × 30 × 135 см', '66,36 BYN'],
                    ]
                },
                {
                    title: 'Тарифы для услуги «Упаковка для автомобильных дисков»',
                    head: ['Пункт', 'Направление', 'Габариты', 'Стоимость, с НДС'],
                     rows: [
                        ['1', 'Все, за исключением городов, указанных в п.2', '60 х 60 х 50 см', '22,68 BYN'],
                        ['2', 'Артем, Благовещенск, Братск, Владивосток, Иркутск, Комсомольск-на-Амуре, Магадан, Петропавловск-Камчатский, Улан-Удэ, Уссурийск, Хабаровск, Чита, Южно-Сахалинск', '60 х 60 х 50 см', '23,52 BYN']
                    ]
                }
            ],
            additionalHtml: `
                <p>* Предоставляется только в филиалах компании в городах Артём, Владивосток, Волгоград, Волжский, Краснодар, Красноярск, Москва, Новосибирск, Санкт-Петербург, Смоленск, Томск.</p>
                <div style="display: flex; gap:12px; align-items: flex-start;">
                     <div style="margin-right: 10px;">
                        <img src="/images/upakovka/icon/warning.svg" alt=""  style="width: 24px; height: 24px;">
                    </div>
                    <div>
                        <p>Расчет стоимости перевозки осуществляется не по габаритам детали, а по габаритам упаковки. Для получения подробной информации Вы можете обратиться к нашему оператору удобным для Вас способом.</p>
                        <p>Данный вид упаковки обязателен при перевозке (за исключением перевозки капотов).</p>
                    </div>
                </div>
            `
        }
    },
    {
        title: 'Упаковка для мотоциклов',
        subtitles: [
            'ПЭК перевозит мототехнику, в том числе квадроциклы, скутеры, водные и кроссовые мотоциклы.',
            'Упаковка для мотоциклов – специализированная жесткая упаковка, гарантирующая сохранность при транспортировке.',
        ],
        img: '/images/upakovka/moto_1.png',
        detailsImg: ['/images/upakovka/moto_2.png','/images/upakovka/moto_3.png'],
        info: {
            title: 'Тарифы для услуги «Упаковка для мотоциклов»',
            tables: [
                {
                    head: ['Пункт', 'Направление', 'Тариф на услугу «Упаковка для мотоциклов»'],
                    rows: [
                        ['1', 'Все, за исключением городов, указанных в п.2.', {html: '102,06 BYN/м³ ,<br>минимальная стоимость: 49,14 BYN'}],
                        ['2', 'При отправке грузов из городов Республики Казахстан', {html: '182,7 BYN/м³, <br>минимальная стоимость: 97,44 BYN'}]
                    ]
                }
            ],
            additionalHtml: `
                 <div style="display: flex; gap:12px; align-items: flex-start;">
                     <div style="margin-right: 10px;">
                        <img src="/images/upakovka/icon/warning.svg" alt=""  style="width: 24px; height: 24px;">
                    </div>
                    <div>
                        <p><b>Данный вид упаковки обязателен для любой мототехники, по которой необходимо наличие защитной транспортировочной упаковки.</b></p>
                        <p>Стоимость перевозки автомобильным транспортом с использованием упаковки для мотоциклов увеличивается на 35%; для авиаперевозки - на 40%.</p>
                    </div>
                </div>
            `
        }
    },
    {
        title: 'Упаковочный материал',
        subtitles: ['Компания предоставляет клиенту возможность самостоятельно упаковать свой груз с использованием специализированного упаковочного материала:'],
        img: '/images/upakovka/prk_1.png',
        detailsImg: ['/images/upakovka/prk_2.png'],
        lists: [
            { img: '/images/upakovka/icon/tabler_glass-gin.svg', text: 'Посуда' },
            { img: '/images/upakovka/icon/setting-2.svg', text: 'Фурнитура' },
            { img: '/images/upakovka/icon/glass.svg', text: 'Хрупкие предметы' },
        ],
        warning: 'Для грузов, входящих в «Перечень грузов, подлежащих обязательной защитной транспортировочной упаковке» данная упаковка не является альтернативой.',
        info: {
            tables: [
                {
                    head: ['Используемый материал:', 'Цена за 1 пог. м.'],
                    rows: [
                        ['ППЭ (пенополиэтилен), толщина 8-10 мм, серый / белый', {html: '3,78 BYN/м<sup>2</sup>'}],
                        ['ППЭ (пенополиэтилен), толщина 2,3-2,5 мм, серый / белый', {html: '2,1 BYN/м<sup>2</sup>'}],
                        ['Картон листовой*', '2,73 BYN']
                    ]
                }
            ],
            additionalHtml: `
                <p>Услуга оказывается только при сдаче груза на складе экспедитора.</p>
                <p>Допускается использование вторичного материала.</p>
                <p>* Количество материала ограничено. Информацию о наличии дополнительной упаковки уточняйте у сотрудников филиала.</p>
            `
        }
    },
    {
        title: 'Защитная транспортировочная упаковка «Пирамида»',
        subtitles: ['Защитная транспортировочная упаковка «Пирамида» разработана для вертикальной перевозки хрупких крупногабаритных грузов, например, стёкол, плит, окон, зеркал, световых панелей. Конструктивная особенность упаковки – пирамидальная опора в центре – позволяет распределить нагрузку и избежать механических повреждений грузов такого типа при транспортировке.'],
        img: '/images/upakovka/pyramid_1.png',
        detailsImg: ['/images/upakovka/pyramid_2.png'],
        lists: [
            { img: '/images/upakovka/icon/si_window-line.svg', text: 'Окна' },
            { img: '/images/upakovka/icon/mirror.svg', text: 'Зеркала' },
            { img: '/images/upakovka/icon/milk.svg', text: 'Стёкла' },
            { img: '/images/upakovka/icon/layer.svg', text: 'Мраморная плита' },
        ],
        info: {
            tables: [
                {
                    title: 'Стоимость двусторонней упаковки:',
                    head: ['Пункт', 'Направления', 'Стоимость'],
                    rows: [
                        ['1', 'Все, за исключением городов, указанных в п.2, п.3', {html: '95,34 BYN за 1 м<sup>3</sup>'}],
                        ['2', 'Артем, Благовещенск, Братск, Владивосток, Иркутск, Комсомольск-на-Амуре, Магадан, Петропавловск-Камчатский, Улан-Удэ, Уссурийск, Хабаровск, Чита, Южно-Сахалинск', {html: '99,54 BYN за 1 м<sup>3</sup>'}],
                        ['3', 'Города республики Казахстан', {html: '166,32 BYN за 1 м<sup>3</sup>'}],
                    ],
                    additionalHtml: `
                    <div style=" font-weight: 400; font-style: Regular; font-size: 14px; leading-trim: NONE; line-height: 20px; letter-spacing: 0%;">
                        <p>Стоимость упаковки и перевозки рассчитывается с учётом объёма изготавливаемой конструкции. Объем конструкции рассчитывается по двум измерениям «Длина груза» и «Высота груза», количество конструкций зависит от общей «Ширины (толщины) груза».</p>
                    </div>
                    `
                },
                 {
                    title: 'Порядок расчета объема груза:',
                    head: [],
                    rows: [
                        [{html: 'Объём конструкции = X * Y * Z'}],
                        ['где'],
                        [{html: 'X = «Длина груза» + 0,1 м,<br>где 0,1 – толщина обрешётки.'}],
                        [{html: 'Y = «Высота груза» * 0,52 + 0,3 м<br>где 0,3 м – толщина обрешетки, 0,52 – расчетный коэффициент'}],
                        [{html: 'Z = «Высота груза» * 0,965 + 0,14 м<br>где 0,14 - высота палета, 0,965 - расчетный коэффициент'}],
                        [{html: '<p><b>Ограничения:</b></p><p>Толщина грузового места не более 0,4 м, по 0,2 м на каждую сторону места.<br>Длина грузового места не более 4 м.<br>Высота грузового места не более 2,4 м.</p>'}],
                        [{html: 'За подробным расчётом объёма можно обратиться к оператору.'}]
                    ]
                },
                {
                    title: 'Стоимость односторонней упаковки:',
                    head: ['Пункт', 'Направления', 'Стоимость'],
                    rows: [
                        ['1', 'Все, за исключением городов, указанных в п.2, п.3', {html: '95,34 BYN за 1 м<sup>3</sup>'}],
                        ['2', 'Артем, Благовещенск, Братск, Владивосток, Иркутск, Комсомольск-на-Амуре, Магадан, Петропавловск-Камчатский, Улан-Удэ, Уссурийск, Хабаровск, Чита, Южно-Сахалинск', {html: '99,54 BYN за 1 м<sup>3</sup>'}],
                        ['3', 'Города республики Казахстан', {html: '175,56 BYN за 1 м<sup>3</sup>'}],
                    ]
                },
                 {
                    title: 'Порядок расчета объема груза:',
                    head: [],
                    rows: [
                        [{html: 'Объём конструкции = X * Y * Z'}],
                        ['где'],
                        [{html: 'X = «Длина груза» + 0,1 м,<br>где 0,1 – толщина обрешётки.'}],
                        [{html: 'Y = «Высота груза» * 0,26 + 0,2 м<br>где 0,2 м – толщина обрешетки, 0,26 – расчетный коэффициент'}],
                        [{html: 'Z = «Высота груза» * 0,965 + 0,14 м<br>где 0,14 - высота палета, 0,965 - расчетный коэффициент'}],
                        [{html: '<p><b>Ограничения:</b></p><p>Толщина грузового места не более 0,2 м.<br>Длина грузового места не более 4 м.<br>Высота грузового места не более 1,4 м.</p>'}],
                        [{html: 'За подробным расчётом объёма можно обратиться к оператору.'}]
                    ]
                }
            ],
            additionalHtml: `
                <div style="display: flex; gap:12px; align-items: flex-start;">
                     <div style="margin-right: 10px;">
                        <img src="/images/upakovka/icon/warning.svg" alt=""  style="width: 24px; height: 24px;">
                    </div>
                    <div>
                        <p>Защитная транспортировочная упаковка «Пирамида» после перевозки передаётся Клиенту вместе с грузом и может быть разобрана по его просьбе.</p>
                    </div>
                </div>
            `
        }
    },
    {
        title: 'Палетирование груза',
        subtitles: ['Размещение груза на транспортировочных палетах с последующей фиксацией нескольким слоями стрейч пленки и дополнительной маркировкой фирменным скотчем «ПЭК».'],
        img: '/images/upakovka/pall.png',
        detailsImg: ['/images/upakovka/pall_2.png'],
        info: {
            additionalHtml: `
                <p><b>Стоимость стандартного палетирования груза:</b></p>
                <ul>
                    <li>26,88 BYN за одно грузовое место;</li>
                    <li>8,4 BYN за одно грузовое место (на палете клиента);</li>
                </ul>
                <p><b>Стоимость усиленного палетирования груза:</b></p>
                <ul>
                    <li>29,4 BYN за одно грузовое место;</li>
                    <li>10,92 BYN за одно грузовое место (на палете клиента);</li>
                </ul>
                <p><b>Условия предоставления услуги:</b></p>
                <ul>
                    <li>вес грузового места с палетом не более 800 кг.</li>
                    <li>габариты груза с палетом не более 1,2 х 0,8 х 1,8 м (д.,ш.,в.)</li>
                </ul>
                <p><b>Стоимость палетирования на нестандартном поддоне клиента:</b></p>
                <ul>
                    <li>8,4 BYN за 1 м<sup>3</sup></li>
                </ul>
                <p><b>Условия предоставления услуги:</b></p>
                <ul>
                    <li>вес грузового места с поддоном не более 800 кг.</li>
                    <li>габариты груза с поддоном не более 1,5 х 1,5 х 1,8 м (д.,ш.,в.)</li>
                </ul>
                <div style="display: flex; gap:12px; align-items: flex-start;">
                     <div style="margin-right: 10px;">
                        <img src="/images/upakovka/icon/warning.svg" alt=""  style="width: 24px; height: 24px;">
                    </div>
                    <div>
                        <p>Если груз больше указанных параметров, состоит из нескольких грузовых мест, то он распределяется на два и более палетов.</p>
                        <p>Палетирование не является альтернативой Защитной транспортировочной упаковке.</p>
                        <p>Длина и ширина грузового места будет изменена согласно длине и ширине поддона!</p>
                    </div>
                </div>
            `
        }
    },
    {
        title: 'Стретчевание',
        subtitles: [
            'Услуга включает в себя процесс упаковки груза с использованием стретч-пленки, которая поможет предотвратить повреждения и загрязнение, а также защитит от влаги.',
            'Услуга отлично подойдет для дополнительной сохранности ваших личных вещей, коробок и чемоданов.'
        ],
        img: '/images/upakovka/bag.png',
        info: {
            additionalHtml: `
                <p><b>Стоимость:</b></p>
                <ul>
                    <li>6,72 BYN за 1 м<sup>3</sup></li>
                    <li>Минимальный тариф — 6,72 BYN</li>
                </ul>
            `
        }
    },
    {
        title: 'Конверт для документов',
        subtitles: ['ПЭК предоставляет возможность перевозки сопроводительных документов в специальном конверте.'],
        img: '/images/upakovka/bg_removal.png',
        detailsImg: ['/images/upakovka/bg_removal_2.png'],
        info: {
            additionalHtml: `
                <p><b>Стоимость услуги «Организация перевозки сопроводительных документов»:</b></p>
                <ul>
                    <li>6,3 BYN вне зависимости от расстояния и направления.</li>
                </ul>
                <p><b>Условия предоставления услуги:</b></p>
                <ul>
                    <li>отправки груза в/из Калининграда, в/из городов Казахстана, Беларуси, Армении, Узбекистана и Таджикистана;</li>
                    <li>использования услуги «Возврат документов»;</li>
                    <li>перевозки грузов авиатранспортом.</li>
                </ul>
                 <div style="display: flex; gap:12px; align-items: flex-start;">
                     <div style="margin-right: 10px;">
                        <img src="/images/upakovka/icon/warning.svg" alt=""  style="width: 24px; height: 24px;">
                    </div>
                    <div>
                        <p>В случае, если клиент перенаправляет груз, услуга подлежит оплате за каждую перенаправку отдельно.</p>
                    </div>
                </div>
            `
        }
    },
    {
        title: 'Перепалечивание груза',
         subtitles: [
            'Данная услуга подойдет для клиентов, которые не уверены в соответствии своей упаковки для сдачи груза, например, в гипермаркет. Мы сами перепалетим ваш груз, будь то отдельные коробки или целый палет в соответствии со всеми нормами гипермаркета.'
        ],
        img: '/images/upakovka/repallet.png',
        info: {
            additionalHtml: `
                <p><b>Стоимость за 1 услугу – 55,44 BYN</b></p>
                <b>Условия предоставления услуги:</b>
                <ul>
                    <li>вес грузового места с палетом не более 800 кг.</li>
                    <li>габариты груза с палетом не более 1,2 х 0,8 х 1,8 м (д.,ш.,в.)</li>
                </ul>
                <div style="display: flex; gap:12px; align-items: flex-start;">
                     <div style="margin-right: 10px;">
                        <img src="/images/upakovka/icon/warning.svg" alt=""  style="width: 24px; height: 24px;">
                    </div>
                    <div>
                        <p>Если груз больше указанных параметров, состоит из нескольких грузовых мест, то он распределяется на два и более палетов.</p>
                        <p>Перепалечивание и последующее палетирование не является альтернативой Защитной транспортировочной упаковке.</p>
                    </div>
                </div>
            `
        }
    },
    {
        title: 'Упаковка груза стреппинг-лентой',
        subtitles: [
            'Компания предоставляет на выбор клиента 2 вида услуг: упаковка груза стреппинг-лентой 12 мм и 16 мм.',
            'Данная услуга предоставляет собой дополнительное крепление груза клиента путем окантовывания полиэстровой стреппинг-лентой.',
            'Стреппинг-лента 12 мм подойдет прежде всего клиентам, которые сдают груз в коробках, для повышения их жесткости и целостности.',
            'Стреппинг-лента 16 мм подойдет клиентам, которые не до конца уверены в устойчивости своего груза, чтобы предотвратить заваливание груза путем дополнительной фиксации к поддону.',
        ],
        img: '/images/upakovka/stape.png',
        info: {
            additionalHtml: `
                <b>Стоимость услуги:</b>
                <ul>
                    <li>Стреппинг-лента 12 мм – 2,31 BYN/м<sup>3</sup></li>
                    <li>Стреппинг-лента 16 мм – 3,15 BYN/м<sup>3</sup></li>
                </ul>
                <div style="display: flex; gap:12px; align-items: flex-start;">
                     <div style="margin-right: 10px;">
                        <img src="/images/upakovka/icon/warning.svg" alt=""  style="width: 24px; height: 24px;">
                    </div>
                    <div>
                        <p>Услуга доступна во всех филиалах ПЭК в России</p>
                        <p>Услуга оформляется при сдаче груза на склад</p>
                    </div>
                </div>
            `
        }
    },
    {
        title: 'Морская защитная упаковка',
        subtitles: ['Если планируете сдавать груз в морской порт, то ПЭК разработал специально для вас новый вид транспортировочной упаковки соответствующей требованиям портов и морской грузоперевозки.'],
        img: '/images/upakovka/marine_packaging_1.png',
        detailsImg: ['/images/upakovka/marine_packaging_2.png'],
        lists: [
            { img: '/images/upakovka/icon/box.svg', text: 'Пластиковая и металлическая тара' },
            { img: '/images/upakovka/icon/cpu.svg', text: 'Техника' },
            { img: '/images/upakovka/icon/car.svg', text: 'Автозапчасти' },
            { img: '/images/upakovka/icon/glass.svg', text: 'Хрупкие предметы' }
        ],
        info: {
            title: 'Стоимость упаковки:',
            tables: [
                {
                    head: ['Услуга', 'Минимальная стоимость, с НДС', {html: 'Тариф за 1 м<sup>3</sup>, с НДС'}],
                    rows: [
                        ['Морская защитная транспортировочная упаковка', '101,22 BYN', '121,38 BYN'],
                        ['Морской защитный транспортировочный ящик', '118,44 BYN', '139,44 BYN']
                    ]
                }
            ],
            additionalHtml: `
                 <div style="display: flex; gap:12px; align-items: flex-start;">
                     <div style="margin-right: 10px;">
                        <img src="/images/upakovka/icon/warning.svg" alt=""  style="width: 24px; height: 24px;">
                    </div>
                    <div>
                        <p>Данная услуга может быть оказана, как в городе отправления груза, так и в городе получения груза для доставки в порт.</p>
                        <p>При заказе услуги в городе отправления стоимость перевозки автомобильным транспортом с использованием Морской защитной транспортировочной упаковки и Морского защитного транспортировочного ящика увеличивается на 35%.</p>
                        <p>Стоимость Морской защитной транспортировочной упаковки и Морского защитного транспортировочного ящика, при максимальном габарите грузового места от 4 м до 6 м увеличивается на 25%; от 6 м стоимость увеличивается на 50%.</p>
                    </div>
                </div>
            `
        }
    },
    {
        title: 'Упаковка для дверей',
        subtitles: ['ПЭК перевозит большую разновидность дверей, и специально для них подойдет специальная услуга Упаковка для дверей, которая обеспечит сохранность дверей с учетом их особенностей и требований к транспортировке.'],
        img: '/images/upakovka/var_1_1.png',
        detailsImg: ['/images/upakovka/var_2_1.png', '/images/upakovka/var_3_1.png'],
        info: {
            title: 'Тарифы на услугу «Упаковка для дверей»',
            tables: [
                {
                    head: ['Пункт', 'Направления', {html: 'Для грузов, которые помещаются в палетную раму*'}],
                    rows: [
                        ['1', 'Все, за исключением городов и отделений, указанных в п.2, п.3, п.4', {html: '100,38 BYN/м<sup>3</sup>,<br>минимальная стоимость: 48,3 BYN'}],
                        ['2', 'При отправке грузов из: Адлер Веселое, Александров, Алексеевка, Анапа, Астрахань, Балашиха, Балашов, Барнаул, Барнаул Власихинская, Березники, Белгород, Бор, Борисоглебск Матросовская, Боровичи, Бугульма, Великие Луки, Владимир, Владикавказ ФР, Волхов, Вольск, Волжский, Воронеж, Воронеж Солнечная, Воскресенск, Выборг Ленинградское, Выкса, Вышний Волочек, Вязники, Вязьма, Вятские Поляны, Гай, Горки Ленинские, Грозный, Гурьевск, Долгопрудный Грибки, Домодедово, Дубна, Евпатория, Егорьевск, Елабуга, Екатеринбург, Железногорск, Жирновск, Заводоуковск, Иваново, Ижевск, Казань, Карасук, Касимов, Козельск, Кореновск, Краснодар, Краснодар Круговая, Краснокамск, Крымск, Кунгур, Курчатов, Лабинск, Ленинградская Станица, Ленинск-Кузнецкий, Людиново, Майкоп Транспортная, Минусинск, Михайловка, Моршанск, Москва, Москва Дзержинский, Москва Молодогвардейская, Муром Владимирское, Набережные Челны, Надым, Назрань, Нижний Новгород, Новосибирск, Новомосковск, Новоуральск, Новошахтинск, Ноябрьск, Нурлат, Обнинск Киевское, Омск, Омск Производственная, Орехово-Зуево Урицкого, Острогожск, Пенза, Пермь, Пермь Героев Хасана, Петрозаводск Перевалка, Петропавловск-Камчатский, Прохладный, Пушкино, Пятигорск, Раменское, Ржев, Рославль, Россошь Мира, Ростов-на-Дону, Ростов-на-Дону Восток, Ртищево, Рузаевка, Самара, Санкт-Петербург, Санкт-Петербург Энергетиков, Саратов, Сергиев Посад Фабричная, Серпухов, Смоленск, Сочи, Стерлитамак Элеваторная, Ступино, Сызрань Речной порт, Сызрань Хвалынская, Талица, Тара, Тихорецк, Туапсе, Томск, Тюмень, Удомля, Урюпинск, Уфа, Феодосия, Челябинск, Черкесск, Шарья, Шебекино, Шумиха, Щекино, Щелково, Элиста, Ярославль, Ярославль Пожарского, Ярцево, Ясный, + МО.', {html: '101,64 BYN/м<sup>3</sup>,<br>минимальная стоимость: 48,72 BYN'}],
                        ['3', 'При отправке грузов из: Артем, Алексин, Ачинск, Балахна, Бийск Шадрина, Братск Южная, Благовещенск, Бугуруслан, Бузулук, Братск Южная,Брест, Верхняя Салда, Владивосток, Волгоград, Волгоград Красноармейский, Георгиевск, Губкин, Дальнегорск, Елец, Зеленоград, Ирбит, Иркутск, Канск, Клин, Комсомольск-на-Амуре, Красноярск, Каменск-Уральский Карла Маркса, Камышин, Канск, Кирово-Чепецк, Клинцы, Краснокаменск, Красноярск Вавилова, Красноярск Северный, Кулебаки, Кызыл, Лесосибирск, Лысьва, Махачкала, Миасс, Магадан, Мичуринск, Минск, Наро-Фоминск Киевское шоссе, Находка, Нефтекамск Высоковольтная, Новый Уренгой, Ногинск, Норильск Море, Норильск Река, Углич, Ухта, Улан-Удэ, Уссурийск, Оренбург Юг, Первоуральск, Саров, Солнечногорск, Степное Озеро, Спасск-Дальний, Таганрог Западный, Тулун, Хабаровск, Хасавюрт, Чайковский, Чита, Южно-Сахалинск Ленина, Якутск.', {html: '103,74 BYN/м<sup>3</sup>,<br>минимальная стоимость: 49,14 BYN'}],
                        ['4', 'При отправке грузов из городов республики Казахстан', {html: '166,74 BYN/м<sup>3</sup>,<br>минимальная стоимость: 85,68 BYN'}]
                    ]
                }
            ],
            additionalHtml: `
                <div style="display: flex; gap:12px; align-items: flex-start;">
                     <div style="margin-right: 10px;">
                        <img src="/images/upakovka/icon/warning.svg" alt=""  style="width: 24px; height: 24px;">
                    </div>
                    <div>
                        <p>Стоимость перевозки автомобильным транспортом с использованием упаковки для дверей увеличивается на 35%; для авиаперевозки - на 40%.</p>
                    </div>
                </div>
            `
        }
    }
];

    return {
        packagings
    }
}
